<div class="page-wrapper">
  <div class="content-wrapper centered">
    <h1>CrewTime</h1>
    <h2>Start Form & Time Sheet App for your movie production team</h2>
    <h2 class="border-top">Start Form és Time Sheet app a forgatócsoportnak</h2>
    <p class="border-top">
      <a href="mailto:sosandris@gmail.com" target="_blank">
      Ask for info and quote
      </a>
      &nbsp;|&nbsp;
      <a href="mailto:sosandris@gmail.com" target="_blank">sosandris@gmail.com</a>
    </p>
  </div>
</div>